import { render, staticRenderFns } from "./LinkedOrders.vue?vue&type=template&id=ae0b4604&"
import script from "./LinkedOrders.vue?vue&type=script&lang=js&"
export * from "./LinkedOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports